import { crudPage } from '../../components/crud-page.js';
import { Responsibles } from '../../api/resources.js';

export default async function ResponsiblesPage(outlet) {
  await crudPage(outlet, {
    title: 'Responsables internos',
    api: Responsibles,
    columns: [
      { key: 'full_name',  label: 'Nombre' },
      { key: 'position',   label: 'Cargo',      render: (r) => r.position || '—' },
      { key: 'department', label: 'Departamento', render: (r) => r.department || '—' },
      { key: 'phone',      label: 'Telefono',   render: (r) => r.phone || '—' },
      { key: 'email',      label: 'Email',      render: (r) => r.email || '—' },
    ],
    formFields: (item) => [
      { name: 'full_name',   label: 'Nombre completo', value: item.full_name, required: true, full: true },
      { name: 'position',    label: 'Cargo', value: item.position },
      { name: 'department',  label: 'Departamento', value: item.department },
      { name: 'phone',       label: 'Telefono', value: item.phone },
      { name: 'email',       label: 'Email', type: 'email', value: item.email },
      { name: 'document_id', label: 'Documento', value: item.document_id },
    ],
  });
}
